import { render, staticRenderFns } from "./proceedingOpinionReg.vue?vue&type=template&id=27bb4329"
import script from "./proceedingOpinionReg.vue?vue&type=script&lang=js"
export * from "./proceedingOpinionReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27bb4329')) {
      api.createRecord('27bb4329', component.options)
    } else {
      api.reload('27bb4329', component.options)
    }
    module.hot.accept("./proceedingOpinionReg.vue?vue&type=template&id=27bb4329", function () {
      api.rerender('27bb4329', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/osh/proceedingOpinionReg.vue"
export default component.exports